import * as actionTypes from '../constants/action-types';

const initialState = {
    isRequesting: false,
    equipmentConfig: {
        equipment_type: [],
        plan_type: [],
        categories: [],
        fields: []
    },
    equipmentTypeList: [],
    categoryTypeList: [],
    subcategoryTypeList: [],
    fields: {
        equipmentType: [],
        category: [],
        subcategory: []
    },
    planTypeList: [],
    equipmentList: [],
    equipmentInfo: [],
    equipmentMakeList: [],
    equipmentModelList: [],
    equipmentVendorList: [],
    vehicleEquipmentList: [],
    implementEquipmentList: [],
    phoneDeviceList: [],
    canDeviceList: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EQUIPMENT_LIST_REQUEST: {
            state = { ...state, isRequesting: true, equipmentList: initialState.equipmentList };
            break;
        }
        case actionTypes.GET_EQUIPMENT_CONFIG: {
            const config = action.payload ? action.payload : initialState.equipmentConfig;
            state = {
                ...state, equipmentConfig: config,
                equipmentTypeList: config.equipment_type,
                planTypeList: config.plan_type,
                categoryTypeList: [], subcategoryTypeList: []
            };
            break;
        }
        case actionTypes.GET_CATEGORY_TYPE_LIST: {
            let planTypeCount = 0;

            const planTypeId = action.hasOwnProperty('planTypeId') ? action.planTypeId : 0;
            const findItems = state.equipmentConfig.categories.filter(e => {
                planTypeCount += (e.parent_id === 0 && e.equipment_type_id === action.equipmentTypeId && e.plan_type_ids.length > 0) ? 1 : 0;

                return (e.parent_id === 0 && e.equipment_type_id === action.equipmentTypeId &&
                    (e.plan_type_ids.length === 0 || (planTypeId > 0 && e.plan_type_ids.indexOf(planTypeId) >= 0)));
            });

            state = {
                ...state, categoryTypeList: findItems,
                fields: getFields(state, action),
                planTypeList: (planTypeCount > 0) ? state.equipmentConfig.plan_type : []
            };
            break;
        }
        case actionTypes.GET_EQUIPMENT_MAKE_LIST:
            state = { ...state, equipmentModelList: [], equipmentMakeList: action.payload ? action.payload : null }
            break;
        case actionTypes.GET_EQUIPMENT_MODEL_LIST:
            state = { ...state, equipmentModelList: action.payload ? action.payload : [] }
            break;
        case actionTypes.GET_EQUIPMENT_VENDOR_LIST:
            state = { ...state, equipmentVendorList: action.payload ? action.payload : [] }
            break;
        case actionTypes.GET_EQUIPMENT_LIST:
            state = { ...state, isRequesting: false, equipmentList: action.payload ? action.payload : [] }
            break;
        case actionTypes.GET_EQUIPMENT_INFO:
            state = { ...state, equipmentInfo: action.payload ? action.payload : [] }
            break;
        case actionTypes.GET_SUB_CATEGORY_TYPE_LIST: {
            const findItems = state.equipmentConfig.categories.filter(e =>
            (e.parent_id > 0 && e.parent_id === action.categoryId
                && e.equipment_type_id === action.equipmentTypeId));
            state = { ...state, subcategoryTypeList: findItems, fields: getFields(state, action) };
            break;
        }
        case actionTypes.GET_EQUIPMENT_FIELDS: {
            state = { ...state, fields: getFields(state, action) };
            break;
        }
        case actionTypes.GET_EQUIPMENT_NAME_LIST: {
            let keyName = '';
            if (action.equipmentType === 'vehicle') keyName = 'vehicleEquipmentList';
            else if (action.equipmentType === 'implement') keyName = 'implementEquipmentList';
            state = { ...state, [keyName]: action.payload };
            break;
        }
        case actionTypes.GET_DEVICE_LIST: {
            if (action.deviceType === 'phone') state = { ...state, phoneDeviceList: action.payload }
            else state = { ...state, canDeviceList: action.payload }
            break;
        }
        case actionTypes.CLEAR_EQUIPMENT_FIELDS:
            state = { ...state, fields: initialState.fields };
            break;
        case actionTypes.CLEAR_EQUIPMENT_LIST:
            state = { ...state, equipmentList: initialState.equipmentList };
            break;
        default:
            break;
    }
    return state;
}

const getFields = (state, params) => {
    if (params.subcategoryId >= 0) {
        const findFields = (params.subcategoryId > 0) ? state.equipmentConfig.fields.filter(e => {
            return (e.category_id === params.subcategoryId);
        }) : [];
        return { ...state.fields, subcategory: findFields };
    } else if (params.categoryId >= 0) {
        const findFields = (params.categoryId > 0) ? state.equipmentConfig.fields.filter(e => {
            return (e.category_id === params.categoryId);
        }) : [];
        return { ...state.fields, category: findFields, subcategory: [] };
    } else if (params.equipmentTypeId >= 0) {
        const findFields = (params.equipmentTypeId > 0) ? state.equipmentConfig.fields.filter(e => {
            return (e.category_id === 0 && e.equipment_type_id === params.equipmentTypeId);
        }) : [];
        return { equipmentType: findFields, category: [], subcategory: [] };
    } else return state.fields;
}